import React, { FunctionComponent, ReactNode } from 'react';

interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
}

/** Hover tooltip (replaces the react-bootstrap OverlayTrigger + Tooltip pair). */
const Tooltip: FunctionComponent<TooltipProps> = ({ content, children }) => (
  <span className="relative group inline-block">
    {children}
    <span
      role="tooltip"
      className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 whitespace-nowrap rounded-sm bg-gray-900 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100 z-30"
    >
      {content}
    </span>
  </span>
);

export default Tooltip;
